// eslint-disable-next-line
const cardStyle = {
	hidePostalCode: true,
	hideIcon: true,
	style: {
		base: {
			backgroundColor: '#f8f3e8',
			color: '#333',
			fontWeight: 400,
			fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
			fontSize: '18px',
			fontSmoothing: 'antialiased',
			padding: '20px',

			'::placeholder': {
				color: '#5c5c5c',
			},
			':-webkit-autofill': {
				color: '#333',
			},
		},
		invalid: {
			color: '#cd2337',
		},
	},
};

export const setupStripeElements = (stripe, clientSecret) => {
	const elements = stripe.elements({
		clientSecret
	});

	const cardNumber = elements.create('cardNumber', cardStyle);
	const cardExpiry = elements.create('cardExpiry', cardStyle);
	const cardCvc = elements.create('cardCvc', cardStyle);

	cardNumber.mount('#stripe-cc-number');
	cardExpiry.mount('#stripe-cc-expiry');
	cardCvc.mount('#stripe-cc-cvc');

	return {
		cardNumber,
		cardExpiry,
		cardCvc,
	};

	// card.on('change', (e) => {
	// 	console.log('change', e);
	// });
};
